import React, { Component } from "react";
export default class Header extends Component {
  calculateTransform(percentage, diff = 1) {
    const calc = (percentage - 1) * (300 / diff);

    if (calc <= -100) {
      return 100;
    } else {
      return calc;
    }
  }
  createHeader = (diff) => {
    const { language } = this.props;
    const size = 40 + diff * 10 + "%";
    return (
      <div
        className={`ball ball-${diff}`}
        style={{
          transform: `translateY(${-this.calculateTransform(
            this.props.percentage,
            diff
          )}%)`,
        }}
      >
        
      </div>
    );
  };
  render() {
    const { language } = this.props;
    return <></>;
  }
}
